import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AmenaComponent } from './components/amena/amena.component';
import { ListadoActivacionesComponent } from './components/listado-activaciones/listado-activaciones.component';
import { OrderDetailComponent } from './components/order-detail/order-detail.component';
import { OrderDocumentComponent } from './components/order-document/order-document.component';
import { GuardDraftGuard } from './services/guard-draft.guard';
import { AmenaIndexComponent } from './components/amena-index/amena-index.component';

const routes: Routes = [       
    {path: '', component: AmenaIndexComponent},
    {path: 'convergente', component: AmenaComponent, canDeactivate: [GuardDraftGuard]},
    {path: 'solo_movil', component: AmenaComponent, canDeactivate: [GuardDraftGuard]},
    {path: 'listado', component: ListadoActivacionesComponent},
    {path: 'order/:from/:order_id', component: OrderDetailComponent},
    {path: 'document/:amena_order_id', component: OrderDocumentComponent} 
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AmenaRoutingModule { }
